import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';

import FormulaireSelectionProjet from '../../../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import FormulaireSelectionDateHeureUnix from '../../../../Graphe/ProfilGraphe/FormulaireGraphe/FormulaireSelectionDateHeureUnix/FormulaireSelectionDateHeureUnix';

import AttenteRequete from '../../../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import { glossaire_alarm_level } from '../../../../../ressources/glossaires/glossaire_niveau_alarme';
import * as requestType from '../../../../../ressources/glossaires/glossaire_requetes';
import * as actions from '../../../../../services/actions';
import Interrupteur from '../../../../UI/Interrupteur/Interrupteur';
import MessageErreur, {
  classeChampEnErreur,
} from '../../../../UI/MessageErreur/MessageErreur';
import {
  schemaNouveauGabaritAlarme,
  schemaModificationGabaritAlarme,
} from '../../../../../services/schemas/gabaritAlarme';
import {
  validerFormulaire,
  messageDuChamp,
} from '../../../../../services/schemas/validerFormulaire';

import { RiMailSendFill } from 'react-icons/all';
import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireGabarit.module.scss';

const FormulaireGabarit = (props) => {
  const [formulaireGabarit, setFormulaireGabarit] = useState({
    project_id: null,
    selected_project_id: null,
    template_name: '',
    start: null,
    end: null,
    private: 0,
    alarm_level: 2,
    template: '',
    template_id: undefined,
  });
  const [erreurs, setErreurs] = useState({});
  const erreurDuChamp = (champ) => messageDuChamp(erreurs, champ);

  useEffect(() => {
    if (props.preconfigurerGabarit !== undefined) {
      setFormulaireGabarit({
        ...props.preconfigurerGabarit,
        template: JSON.stringify(props.preconfigurerGabarit.template),
      });
    }
  }, [props.preconfigurerGabarit]);

  // Toutes les mises à jour partent de l'état courant (prev) et non de la
  // copie capturée au rendu. FormulaireSelectionProjet et
  // FormulaireSelectionDateHeureUnix rappellent leurs gestionnaires depuis
  // un useEffect : avec la copie capturée, un tel rappel réécrivait l'état
  // d'avant et effaçait ce que l'utilisateur venait de taper.
  const modifier = (changements) =>
    setFormulaireGabarit((prev) => ({ ...prev, ...changements }));

  const gererEtatDeCibleName = (event) =>
    modifier({ [event.target.name]: event.target.value });

  const gererTemplate = (event) => modifier({ template: event.target.value });

  // Stable d'un rendu à l'autre : FormulaireSelectionProjet la liste dans les
  // dépendances de son useEffect et l'appelle tant qu'aucun projet n'est
  // choisi. Recréée à chaque rendu, elle relançait l'effet, qui la rappelait,
  // qui provoquait un rendu : une boucle sans fin, dans laquelle aucune saisie
  // du formulaire ne tenait.
  const gererProjetId = useCallback(
    (projetId) =>
      setFormulaireGabarit((prev) => ({
        ...prev,
        project_id: projetId,
        selected_project_id: projetId,
      })),
    []
  );

  const gererDebut_time_interval = (unix) => modifier({ start: unix });

  const gererFin_time_interval = (unix) => modifier({ end: unix });

  const reqEnvoi = () => {
    /**
     * envoie la requête de création ou modification de gabarit
     * @type {{template_name: (string|*), list_emails: ([]|*), project_id: number}}
     */
    // Les champs partent tels que saisis, le gabarit encore en texte : le
    // schéma convertit et refuse avec un message ce qui ne peut pas l'être.
    // Un JSON illisible faisait jusqu'ici échouer JSON.parse ici même, et
    // l'envoi s'arrêtait sans que rien ne s'affiche.
    const enCreation = formulaireGabarit.template_id === undefined;
    const formulaireGabaritForRequest = {
      //création de l'objet à envoyer
      project_id: formulaireGabarit.project_id,
      template_name: formulaireGabarit.template_name,
      start: formulaireGabarit.start,
      end: formulaireGabarit.end,
      private: formulaireGabarit.private,
      alarm_level: formulaireGabarit.alarm_level,
      template: formulaireGabarit.template,
    };
    if (!enCreation) {
      formulaireGabaritForRequest.template_id = formulaireGabarit.template_id;
    }

    const resultat = validerFormulaire(
      enCreation ? schemaNouveauGabaritAlarme : schemaModificationGabaritAlarme,
      formulaireGabaritForRequest
    );
    setErreurs(resultat.erreurs);
    if (!resultat.valide) {
      return;
    }

    if (enCreation) {
      props.reqAjouter(resultat.donnees);
    } else {
      props.reqModifier(resultat.donnees);
    }
  };
  /*
   */
  return (
    <>
      <div className={[styles.ConteneurInfo].join(' ')}>
        <div
          className={[
            s.container,
            s.border,
            s.text_left,
            styles.Formulaire,
          ].join(' ')}
        >
          <div>
            <div className="radio">
              <label onClick={() => modifier({ project_id: null })}>
                <input type="radio" checked={!formulaireGabarit.project_id} />
                {checkMot('acces_libre')}
              </label>
            </div>
            <div className="radio">
              <label
                onClick={() =>
                  setFormulaireGabarit((prev) => ({
                    ...prev,
                    project_id: prev.selected_project_id,
                  }))
                }
              >
                <input type="radio" checked={formulaireGabarit.project_id} />
                <FormulaireSelectionProjet
                  affichageProfil={props.affichageProfil}
                  gererProjetId={gererProjetId}
                  preconfigurerProjetId={formulaireGabarit.project_id}
                />
                {/**FIN project_id**/}
              </label>
            </div>
            <MessageErreur cle={erreurDuChamp('project_id')} />
          </div>
          <div className={s.form_group}>
            <label
              className={[styles.label].join(' ')}
              htmlFor="inlineFormCustomSelect"
            >
              {checkMot('template_name')}
            </label>
            <div className={[s.form_row, s.align_items_center].join(' ')}>
              <div className={s.col_12}>
                <input
                  type="text"
                  pattern="[0-9a-zA-Z._%+-\\s ]+"
                  className={[
                    s.form_control,
                    s.mb_2,
                    erreurDuChamp('template_name') ? classeChampEnErreur : '',
                  ].join(' ')}
                  name="template_name"
                  placeholder="template_name"
                  value={formulaireGabarit.template_name}
                  disabled={props.affichageProfil}
                  onChange={(event) => gererEtatDeCibleName(event)}
                />
                <MessageErreur cle={erreurDuChamp('template_name')} />
              </div>
            </div>
          </div>
          {/**template_name**/}

          <div className={s.form_group}>
            {/**DEBUT time_interval**/}
            <div className={[s.form_row, s.align_items_center].join(' ')}>
              <span className={s.col_12}>
                {checkMot(
                  "Interval de temps sur lequel le gabarit s'applique [début, fin]"
                )}
              </span>
              <div className={s.col_6}>
                <FormulaireSelectionDateHeureUnix
                  value={formulaireGabarit.start}
                  gereUnixDate={gererDebut_time_interval}
                  disabled={props.affichageProfil}
                />
              </div>
              <div className={s.col_6}>
                <FormulaireSelectionDateHeureUnix
                  value={formulaireGabarit.end}
                  gereUnixDate={gererFin_time_interval}
                  disabled={props.affichageProfil}
                />
                <MessageErreur cle={erreurDuChamp('end')} />
              </div>
            </div>
          </div>
          {/**FIN time_interval**/}

          {/**DEBUT private**/}
          <div className={[s.form_row, styles.heder].join(' ')}>
            <div className={s.col_12}>
              <label className={styles.stil2}>{checkMot('acces_prive')}</label>
              {/* Même interrupteur que pour le graphe. Sans valeur, la liste
                  qui précédait affichait « publique », l'état initial valant
                  0 : même lecture ici. */}
              <Interrupteur
                name="private"
                label={checkMot('prive')}
                valeur={formulaireGabarit.private ?? 0}
                disabled={props.affichageProfil}
                onChange={(valeur, nom) => modifier({ [nom]: valeur })}
              />
            </div>
          </div>
          {/**FIN private**/}
          {/**DEBUT alarm_level**/}
          <div className={[s.form_row, styles.heder].join(' ')}>
            <div className={s.col_12}>
              <label className={styles.stil2}>{checkMot('alarm_level')}</label>
              <select
                onChange={(event) => gererEtatDeCibleName(event)}
                name="alarm_level"
                defaultValue={formulaireGabarit.alarm_level}
                disabled={props.affichageProfil}
                value={formulaireGabarit.alarm_level}
                className={[s.custom_select, styles.stile].join(' ')}
              >
                {Object.keys(glossaire_alarm_level)
                  .filter((key) => parseInt(key) !== 9)
                  .map((key) => (
                    <option key={key} value={key}>
                      {checkMot(glossaire_alarm_level[key])}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          {/**FIN alarm_level**/}
          <div className={[s.form_row, styles.heder].join(' ')}>
            <label className={styles.stil2}>{checkMot('template')}</label>
            <textarea
              className={[
                s.form_control,
                styles.textarea,
                erreurDuChamp('template') ? classeChampEnErreur : '',
              ].join(' ')}
              placeholder={checkMot('template')}
              name={'template'}
              value={formulaireGabarit.template}
              disabled={props.affichageProfil}
              onChange={(event) => gererTemplate(event)}
            />
            <MessageErreur cle={erreurDuChamp('template')} />
          </div>
          {/**FIN template**/}
          {!props.affichageProfil ? (
            props.preconfigurerGabarit !== undefined ? (
              <>
                <AttenteRequete
                  request_type={requestType.modifier_un_gabarit}
                  str={checkMot('modification_en_cours')}
                >
                  <button className={styles.btF} onClick={reqEnvoi}>
                    <RiMailSendFill size={24} />{' '}
                    {checkMot('envoi_modification')}
                  </button>
                </AttenteRequete>
              </>
            ) : (
              <>
                <AttenteRequete
                  request_type={requestType.creer_un_gabarit}
                  str={checkMot('creation_en_cours')}
                >
                  <button className={styles.btF} onClick={reqEnvoi}>
                    <RiMailSendFill size={24} /> {checkMot('envoi_creation')}
                  </button>
                </AttenteRequete>
              </>
            )
          ) : null}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    reqAjouter: (formulaireGabarit) =>
      dispatch(actions.reqCreerGabarit(formulaireGabarit)),
    reqModifier: (idGabarit) => dispatch(actions.reqModifierGabarit(idGabarit)),
  };
};

export default connect(null, mapDispatchToProps)(FormulaireGabarit);
